var map = {
	"./fart-01.wav": 5509,
	"./fart-02.wav": 3824,
	"./fart-03.wav": 7196,
	"./fart-04.wav": 781,
	"./fart-05.wav": 5465,
	"./fart-06.wav": 7296,
	"./fart-07.wav": 9756,
	"./fart-08.wav": 875,
	"./fart-09.wav": 2242,
	"./fart-10.wav": 8866,
	"./fart-11.wav": 1246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;